// extracted by mini-css-extract-plugin
export var addButton = "_fy-0";
export var border = "_fy-8";
export var check = "_fy-h";
export var danger = "_fy-6";
export var dropdownContainer = "_fy-1";
export var editModalBody = "_fy-j";
export var footerContainer = "_fy-i";
export var fullWidth = "_fy-a";
export var hide = "_fy-9";
export var icon = "_fy-3";
export var input = "_fy-7";
export var inputFlex = "_fy-b";
export var inputWrapper = "_fy-c";
export var manualFocus = "_fy-5";
export var optionButton = "_fy-4";
export var pillWrapper = "_fy-e";
export var pointer = "_fy-2";
export var showOverflow = "_fy-f";
export var tagsFlex = "_fy-d";
export var xButton = "_fy-g";